require('slick-carousel');

if($('.testimonials').length) {

    $('.testimonials').each(function () {

        let testimonialCarousel = $(this),
            slider = testimonialCarousel.find('.testimonials-slider');

        let carousel = slider.slick({
            slidesToScroll: 1,
            slidesToShow: 1,
            dots: true,
            arrows: true,
            fade: true,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        arrows: false
                    }
                }
            ]
        });

    });

}
